import objectPath from 'object-path';

import LayoutConfig from '../layout/LayoutConfig';
import { DEFAULT_MENU_CONFIG } from '../layout/MenuConfig';

export const actionTypes = {
  SetMenuConfig: 'builder/SET_MENU_CONFIG',
  SetLayoutConfigs: 'builder/SET_LAYOUT_CONFIGS',
  SetLayoutConfigsWithPageRefresh:
    'builder/SET_LAYOUT_CONFIGS_WITH_PAGE_REFRESH',
  SetHtmlClassService: 'builder/SET_HTML_CLASS_SERVICE',
  ResetBuilder: 'builder/RESET_BUILDER',
  SetDomainName: 'builder/SET_DOMAIN_NAME',
  SetSettings: 'builder/SET_SETTINGS',
  SetIsApple: 'builder/SET_IS_APPLE',
  SetDefaultSettings: 'builder/SET_DEFAULT_SETTINGS'
};

export const selectors = {
  getClasses: (store, params) => {
    const { htmlClassServiceObjects } = store.builder;

    return htmlClassServiceObjects
      ? htmlClassServiceObjects.getClasses(params.path, params.toString)
      : '';
  },
  getAttributes: (store, params) => {
    if (params.path) {
      // if path is specified, get the value within object
      const { htmlClassServiceObjects } = store.builder;

      return htmlClassServiceObjects
        ? htmlClassServiceObjects.getAttributes(params.path)
        : [];
    }

    return [];
  },
  getConfig: (state, path) => {
    const { layoutConfig } = state.builder;

    if (path) {
      // if path is specified, get the value within object
      return objectPath.get(layoutConfig, path);
    }

    return '';
  },

  getLogo: ({ builder: { layoutConfig } }) => {
    const menuAsideLeftSkin = objectPath.get(layoutConfig, 'brand.self.skin');
    // set brand logo
    const logoObject = objectPath.get(layoutConfig, 'self.logo');
    let logo;
    if (typeof logoObject === 'string') {
      logo = logoObject;
    }

    if (typeof logoObject === 'object') {
      logo = objectPath.get(logoObject, menuAsideLeftSkin + '');
    }

    if (typeof logo === 'undefined') {
      try {
        const logos = objectPath.get(this.layoutConfig, 'self.logo');
        logo = logos[Object.keys(logos)[0]];
      } catch (e) {}
    }
    return logo;
  },

  getStickyLogo: store => {
    const { layoutConfig } = store.builder;
    let logo = objectPath.get(layoutConfig, 'self.logo.sticky');
    if (typeof logo === 'undefined') {
      logo = selectors.getLogo(store);
    }
    return logo + '';
  },

  getDomainName: store => {
    const { domainName } = store.builder;
    return domainName;
  },

  getDefaultSettings: store => {
    const { defaultSettings } = store.builder;
    return defaultSettings;
  }
};

const initialState = {
  menuConfig: DEFAULT_MENU_CONFIG,
  layoutConfig: LayoutConfig.default,
  htmlClassServiceObjects: undefined
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SetMenuConfig:
      return { ...state, menuConfig: payload };

    case actionTypes.SetLayoutConfigs:
      return { ...state, layoutConfig: payload };

    case actionTypes.SetLayoutConfigsWithPageRefresh: {
      return { ...state, layoutConfig: payload };
    }
    case actionTypes.SetHtmlClassService:
      return { ...state, htmlClassServiceObjects: payload };

    case actionTypes.SetDomainName:
      return { ...state, domainName: payload };

    case actionTypes.SetDefaultSettings:
      return { ...state, defaultSettings: payload };

    case actionTypes.SetSettings:
      return { ...state, settings: payload };

    case actionTypes.SetIsApple:
      return { ...state, isAppleDevice: payload };

    case actionTypes.ResetBuilder:
      return {
        ...initialState,
        layoutConfig: { ...initialState.layoutConfig },
        domainName: state.domainName
      };

    default:
      return state;
  }
};

export const actions = {
  setMenuConfig: payload => ({ payload, type: actionTypes.SetMenuConfig }),

  setLayoutConfigs: payload => ({
    payload,
    type: actionTypes.SetLayoutConfigs
  }),

  setLayoutConfigsWithPageRefresh: payload => ({
    payload,
    type: actionTypes.SetLayoutConfigsWithPageRefresh
  }),

  setHtmlClassService: payload => ({
    payload,
    type: actionTypes.SetHtmlClassService
  }),

  setDomainName: payload => ({
    payload,
    type: actionTypes.SetDomainName
  }),

  setSettings: payload => ({
    payload,
    type: actionTypes.SetSettings
  }),

  setDefaultSettings: payload => ({
    payload,
    type: actionTypes.SetDefaultSettings
  }),

  setIsApple: payload => ({
    payload,
    type: actionTypes.SetIsApple
  }),

  resetBuilder: () => ({
    type: actionTypes.ResetBuilder
  })
};
